import React from "react";

import { alert } from "./Alert";
import {
  formatPhoneNumberForInput,
  getDigitsOnly,
} from "../../utils/phoneUtils";

const PhoneNumberInput = ({
  value,
  onChange,
  onKeyDown,
  className = "",
  onEnterPress,
}) => {
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const digits = getDigitsOnly(inputValue);

    if (digits.length <= 10) {
      const formatted = formatPhoneNumberForInput(digits);
      onChange(formatted);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    const digits = getDigitsOnly(pastedText);

    if (!/[0-9]/.test(pastedText)) {
      alert("error", "Phone numbers can't contain letters");
      return;
    }

    if (digits.length > 10) {
      alert("error", "Phone numbers can't be longer than 10 digits");
      return;
    }

    const formatted = formatPhoneNumberForInput(digits);
    onChange(formatted);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && value.trim() && onEnterPress) {
      onEnterPress();
    } else if (
      !/[0-9]/.test(e.key) &&
      ![
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
      ].includes(e.key) &&
      !(e.metaKey || e.ctrlKey) // Allow Cmd/Ctrl key combinations (for things like copy/paste)
    ) {
      e.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  return (
    <div className="relative">
      <div className="absolute z-decorator left-3 top-1/2 -translate-y-1/2 text-secondary text-sm pointer-events-none">
        +1
      </div>
      <input
        type="tel"
        value={value}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onPaste={handlePaste}
        placeholder="(123) 456-7890"
        className={`w-full h-12 py-sm rounded-standard bg-input text-base text-primary text-center transition-all placeholder:text-placeholder shadow-[0px_0px_10px_0px_var(--shadow-primary)] border-2 border-input focus:shadow-[0px_0px_10px_0px_var(--shadow-focus)] focus:border-brand focus:outline-none hover:shadow-[0px_0px_10px_0px_var(--shadow-focus)] ${className}`}
        autoFocus={true}
        data-testid="phone-number-input"
      />
    </div>
  );
};

export default PhoneNumberInput;
